import React from 'react';
import ActionButton from '../../../libs/react-components-admin/buttons/action-button';
import DeleteButton from '../../../libs/react-components-admin/buttons/delete-button';

class ConnectedAccounts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      newAccountName: null,
    };
  }

  render() {
    const connectAccountButtonDisabled = !this.state.newAccountName;
    return <ul className="list-group">
      {this.props.accounts.map(account =>
        <li key={account.id} className="list-group-item">
          <div className="row align-items-center">
            <div className="col">
              {account.name || ''}
            </div>
            <div className="col-auto">
              <DeleteButton action={() => this.props.deleteAction(account.id)}
                            errorHandler={this.props.errorHandler}/>
            </div>
          </div>
        </li>
      )}
      {(this.props.maxAccounts == null || this.props.accounts.length < this.props.maxAccounts) &&
      <li className="list-group-item">
        <div className="row my-2">
          <div className="col">
            <input type="text"
                   className="form-control form-control-sm"
                   placeholder={this.props.accounts.length === 0 ? 'Enter a name' : 'To connect another account, enter a name here first'}
                   value={this.state.newAccountName || ''}
                   onChange={e => this.setState({newAccountName: e.target.value})}/>
            {this.props.accounts.length === 0 &&
            <div className="form-text">Helps you identify the account</div>
            }
          </div>
          <div className="col-auto">
            <ActionButton className={this.props.connectButtonClassName || 'btn-sm btn-primary'}
                          action={() => this.props.connectAction(this.state.newAccountName)}
                          errorHandler={this.props.errorHandler}
                          disabled={connectAccountButtonDisabled}>
              {this.props.connectButtonContentFn ? this.props.connectButtonContentFn(connectAccountButtonDisabled) : 'Connect account'}
            </ActionButton>
          </div>
        </div>
      </li>
      }
    </ul>;
  }

}
export default ConnectedAccounts;